import QueryVisualization from './QueryVisualization';

export default QueryVisualization;
